import { Level2Wrapper } from '../common/Level2Wrapper';
import { ImageList } from '../common/ImageList';
import { GenericSubSection } from '../common/GenericSubSection';
import { useExteriorSectionData } from '../../hooks/useExteriorSection';
import { useLevel1SectionData } from '../../hooks/useLevel1Section';

const generalSections = [
  'driver_doors',
  'passenger_doors',
  'driver_side_rocker',
  'passenger_side_rocker',
  'under_body',
  'driver_quarter',
  'passenger_rear_quarter',
  'trunk_driver_side',
  'trunk_passenger_side',
  'spare_tire'
];

export const FitFinishFrame = () => {
  const { images, subSections } = useExteriorSectionData('fit_finish_frame');
  const { subSections: underHoodSubSections } = useLevel1SectionData('under_hood');

  return (
    <Level2Wrapper flex="1 1 100%" label="Fit Finish & Frame">
      <ImageList label="Fit Finish & Frame Pictures" images={images} />
      {underHoodSubSections.frame_fit_finish_under_hood?.grade && (
        <GenericSubSection section={underHoodSubSections.frame_fit_finish_under_hood} />
      )}
      {underHoodSubSections.under_hood_3_point_body_lines_paint_check?.grade && (
        <GenericSubSection section={underHoodSubSections.under_hood_3_point_body_lines_paint_check} />
      )}
      {generalSections.map(sectionKey => {
        const section = subSections[sectionKey];
        if (!section || !section.grade) return null;
        return <GenericSubSection key={sectionKey} section={subSections[sectionKey]} />;
      })}
    </Level2Wrapper>
  );
};
